import posthog from 'posthog-js';

// PostHog must NEVER initialise on Tier B (public showcase / booking / site-preview
// pages). Those visitors are creators' clients and have not accepted any ToS.
// Init is gated behind a successful authentication in useAuth, so cookies +
// localStorage state only appear inside the authenticated dashboard surface.
// See tasks/explorations/cookies-audit-2026-05-13.html for the categorical rule.

const apiKey = import.meta.env.VITE_POSTHOG_KEY;
const apiHost = import.meta.env.VITE_POSTHOG_HOST;

export function initPostHog(): void {
  if (posthog.__loaded) return;
  if (!apiKey || !import.meta.env.PROD) return;
  posthog.init(apiKey, {
    api_host: apiHost || 'https://eu.i.posthog.com',
    autocapture: true,
    capture_pageview: true,
    capture_pageleave: true,
    person_profiles: 'identified_only',
    persistence: 'localStorage+cookie',
  });
}

export { posthog };
